var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.055a.951.951 0 01-.512.875.76.76 0 01-.905-.205l-5.34-6.063a1.034 1.034 0 010-1.332l5.338-6.055a.76.76 0 01.903-.205.95.95 0 01.513.875L13 16.055z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default ForwardRef;